import React, { Fragment } from "react";

const DiscussionInfoOverlay = ({ profile, setoverlay }) => {
  return (
    <Fragment>
      <div className="profile-picture-overlay">
        <div className="discussion-info-box">
          <i
            className="fas fa-times info-x fa-3x green"
            onClick={() => setoverlay(false)}
          ></i>
          <div className="stream-grid-container">
            <div className="stream-info">
              <img
                className="streamer-user-avi"
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                alt=""
              />
              <div className="helper-container">
                <p className="stream-description">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nam
                  ratione aut eaque dolor ea temporibus laboriosam laborum
                  recusandae odio omnis.
                </p>
              </div>
            </div>
            <div className="stream-lower-info-participant">
              <ul class="creator-stream-items">
                <li class="stream-item green bold">{profile.channelid}</li>
                <li class="stream-item">
                  {profile.firstname} {profile.lastname}
                </li>
                <li class="stream-item">{profile.jobtitle}</li>
                <li class="stream-item">
                  {profile.location && profile.location.city},{" "}
                  {profile.location && profile.location.state}
                </li>
              </ul>
              <ul class="user-count-items">
                <li class="user-count-item">
                  <i class="fas fa-user-friends fa-lg mr-5 green"></i>
                  <span class="green mr-5 bold">Friends</span>
                  <span class="white bold">552</span>
                </li>
                <li class="user-count-item">
                  <i class="fas fa-check fa-lg mr-5 green"></i>
                  <span class="green mr-5 bold">Followers</span>
                  <span class="white bold">5,852</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DiscussionInfoOverlay;
